import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Silencia o aviso benigno "ResizeObserver loop completed with undelivered notifications"
// (gerado pelo Monaco Editor e outros componentes que medem layout).
const RESIZE_OBSERVER_ERR = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
window.addEventListener("error", (e) => {
	if (e?.message && RESIZE_OBSERVER_ERR.test(e.message)) {
		e.stopImmediatePropagation();
		e.preventDefault();
	}
});
window.addEventListener("unhandledrejection", (e) => {
	const msg = e?.reason?.message || String(e?.reason || "");
	if (RESIZE_OBSERVER_ERR.test(msg)) {
		e.stopImmediatePropagation();
		e.preventDefault();
	}
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

reportWebVitals();
